import { useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";

export const PhotoPicker = ({ value, onChange, max = 4, testid }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (files) => {
    const list = Array.from(files).filter((f) => f.type.startsWith("image/")).slice(0, max - value.length);
    if (!list.length) return;
    setBusy(true);
    const urls = [];
    for (const f of list) {
      const fd = new FormData(); fd.append("file", f);
      try { urls.push((await api.post("/public/upload", fd)).data.url); } catch (e) { toast.error(errMsg(e, "A photo didn't upload.")); }
    }
    onChange([...value, ...urls]);
    setBusy(false);
  };

  return (
    <div className="lg-photos" data-testid={testid}>
      {value.map((u, i) => (
        <div className="lg-thumb" key={u}>
          <img src={fileUrl(u)} alt="Uploaded screenshot" />
          <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} data-testid={`${testid}-remove-${i}`}><X size={12} /></button>
        </div>
      ))}
      {value.length < max && (
        <button type="button" className="lg-addphoto" onClick={() => input.current.click()} disabled={busy} data-testid={`${testid}-add`}>
          {busy ? "Uploading…" : <span><ImagePlus size={18} style={{ margin: "0 auto 4px" }} />Add</span>}
        </button>
      )}
      <input ref={input} type="file" accept="image/*" multiple hidden onChange={(e) => { pick(e.target.files); e.target.value = ""; }} data-testid={`${testid}-input`} />
    </div>
  );
};
